import { useQuery, useMutation, useQueryClient, UseQueryResult, UseMutationResult } from "react-query";
import { useAuth } from "../../sdk/hooks";
import * as scheduleApi from "../../sdk/utils/api/price-change-schedule";

export const useGetNotificationConfig = (
    queryKey: string
): UseQueryResult<{ emails: string[] }> => {
    const { token } = useAuth();

    return useQuery<{ emails: string[] }>(queryKey, async () => {
        if (!token) throw new Error("Not authenticated");
        return await scheduleApi.getNotificationConfig(token);
    });
};

export const useUpdateNotificationConfig = (
    invalidQueryKeys: string | string[]
): UseMutationResult<{ emails: string[] }, unknown, string[]> => {
    const { token } = useAuth();
    const queryClient = useQueryClient();

    return useMutation<{ emails: string[] }, unknown, string[]>(
        async (emails: string[]) => {
            if (!token) throw new Error("Not authenticated");
            return await scheduleApi.updateNotificationConfig(token, emails);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(invalidQueryKeys);
            },
        }
    );
};
